import {useLayoutEffect, useState} from 'react';

const useMobileSize = (rule: [string, string]) => {
  if (rule?.length < 2) {
    throw new Error('Неверно заданное правило сравнения');
  }
  if (typeof rule[0] !== 'string') {
    throw new Error('Первым элементом в правиле должен быть знак сравнения');
  }
  if (typeof rule[1] !== 'string' || !rule[1].endsWith('px')) {
    throw new Error(
      'Вторым элементом в правиле должно быть значение в пикселях'
    );
  }
  const isEq = (value: number): boolean => {
    const ruleValue = parseInt(rule[1], 10);
    switch (rule[0]) {
      case '>':
        return value > ruleValue;
      case '>=':
        return value >= ruleValue;
      case '<':
        return value < ruleValue;
      default:
        return value <= ruleValue;
    }
  };
  const [size, setSize] = useState(isEq(window.innerWidth));
  useLayoutEffect(() => {
    function updateSize() {
      setSize(isEq(window.innerWidth));
    }

    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
};
export default useMobileSize;
